import React from "react";
import { Link } from "react-router-dom";
import "./BackButton.css";

export default function BackButton({ to = "/", label = "返回", className = "" }) {
  const cls = ["app-back", className].filter(Boolean).join(" ");
  return (
    <Link className={cls} to={to} aria-label={label}>
      ← {label}
    </Link>
  );
}
